import { createContext } from "react";

const DailyDarshanContext = createContext({});

export default DailyDarshanContext;
